module.exports = __webpack_public_path__ + "static/insight1-187c56204fc322851f45dc016bc904ca.png";